<h2 mat-dialog-title>Quick Edit Agents</h2>
<mat-dialog-content class="mat-typography">
  <div class="header-container">
    <div class="sensitivity-label-selection">
      <sensitivity-labels
        [label]="sensitivityLabel.value"
        (labelSelected)="labelSelected($event)"
      ></sensitivity-labels>
      <span>{{sensitivityLabelText}}</span>
    </div>

    <div class="action-button-container">
        <button matIconButton type="button" (click)="onCancel()" matTooltip="Cancel" matTooltipPosition="above" aria-label="Cancel">
          <mat-icon class="material-symbols-outlined" fontIcon="cancel" mat-dialog-close />
        </button>
      <button matIconButton type="button" (click)="onSave()" matTooltip="Save" matTooltipPosition="above" aria-label="Save">
        <mat-icon class="material-symbols-outlined" fontIcon="save" />
      </button>
    </div>
  </div>

  <div class="agents-grid">
    <kendo-grid id="session-tbl"
              class="table-wrapper"
              [kendoGridBinding]="gridView"
              [sortable]="true"
              [resizable]="true"
              [pageSize]="pageSize"
              [pageable]="true"
              [scrollable]="'scrollable'"
              [(selectedKeys)]="agentSelections"
              [selectable]="true"
              kendoGridSelectBy="id"
              [columnMenu]="{ filter: true }"
              [rowClass]="rowCallback"
              [sort]="sort">

      <ng-template kendoGridToolbarTemplate>
        <kendo-textbox [style.width.px]="350"
                     placeholder="Search in all columns..."
                     (valueChange)="onFilter($event)"></kendo-textbox>
        <!-- Info button -->
        <app-info-button-tooltip
          [tooltipText]="'This search bar filters the following data/columns: Name and Description.'"
          [tooltipPosition]="'above'"
        />
        <button kendoButton type="button"
                (click)="sortCheckboxColumn()" [disabled]="this.agentSelections.length === 0" class="btn-sort" [svgIcon]="sortIcon">
          Sort by Selected Agents
        </button>
      </ng-template>


      <kendo-grid-checkbox-column field="checkboxField"
                                [width]="45"
                                [class]="{ 'text-center': true }"
                                [resizable]="false"
                                [columnMenu]="false"
                                [showSelectAll]="true"></kendo-grid-checkbox-column>

      <kendo-grid-column field="id" title="Id" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="name" title="Name"></kendo-grid-column>
      <kendo-grid-column field="description" title="Description"></kendo-grid-column>
      <kendo-grid-column field="sensitivityLabelList" title="Sensitivity Labels" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="ownerList" title="ownerList" [hidden]="true"></kendo-grid-column>
      <kendo-grid-column field="supportUrl" title="Support Page" [width]="140">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a [href]="dataItem.supportUrl" target="_blank">
            <mat-icon fontIcon="open_in_new" class="material-symbols-outlined" />
          </a>
        </ng-template>
      </kendo-grid-column>

      <ng-template kendoPagerTemplate
                 let-totalPages="totalPages"
                 let-currentPage="currentPage">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-numeric-buttons [buttonCount]="2"></kendo-pager-numeric-buttons>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
        <kendo-pager-input></kendo-pager-input>
        <kendo-pager-info></kendo-pager-info>
        <kendo-pager-page-sizes [pageSizes]="pageSizes"></kendo-pager-page-sizes>
      </ng-template>
    </kendo-grid>
  </div>
</mat-dialog-content>
